import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';



export const findStockRemovalDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/purchase/detail/${id}`,
        method: 'GET',
    })
}
// export const downloadPDF = (id) => {
//     return request({
//         url: `${baseUrl}/joins-invoice-system/v1/purchase/exportPurchaseDetail/${id}`,
//         method: 'GET',
//     })
// }
export const downloadPDF = (params) => {
    params = parseParam(params)
    let url = `${baseUrl}` + `/joins-work/v1/workOrderAudit/exportPurchaseDetail/${params}`
    window.open(url);
}
export const stockRemovalReturn = (id, params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/purchase/dissident/${id}?` + params,
        method: 'GET'
    })
}

export const stockRemoval = (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/purchase/removal/${id}`,
        method: 'PUT'
    })
}
// export const stockRemovalReturn = (params) => {
//     params = parseParam(params)
//     return request({
//         url: `${baseUrl}/joins-invoice-system/v1/purchase/dissident?` + params,
//         method: 'GET'
//     })
// }